module.exports = __webpack_public_path__ + "img/microsoft_logo.7cabc3b5.svg";